import {
  FinancialStatementReportItem,
  AgingSummaryReportItem,
  RevenueRecognitionReportItem,
  ReportItem,
  TrialBalanceReportItem,
  CustomReportItem,
} from "types/Models/consolidatedReport";
import {
  isFinancialStatementReport,
  isAgingSummaryReport,
  isRevenueRecognitionReport,
  isTrialBalanceReport,
  isCustomReport,
} from "utils/allReports";
import { FinancialStatementModal } from "./FinancialStatementModal";
import { AgingSummaryModal } from "./AgingSummaryModal";
import { RevenueRecognitionModal } from "./RevenueRecognitionModal";
import { TrialBalanceModal } from "./TrialBalanceModal";
import { CustomReportModal } from "./CustomReportModal";

type ReportConfigModalProps = {
  isOpen: boolean;
  onClose: () => void;
  report: ReportItem | null;
  isEditMode: boolean;
  onSave: (updatedReport: ReportItem) => void;
  entityId: string;
  selectedReports?: ReportItem[];
};

export const AllReportModals = ({
  isOpen,
  onClose,
  report,
  isEditMode,
  onSave,
  entityId,
  selectedReports = [],
}: ReportConfigModalProps) => {
  if (!report) return null;

  const modalTitle = isEditMode ? `Edit ${report.name}` : `Add ${report.name}`;
  const submitText = isEditMode ? "Save" : "Add";

  if (isFinancialStatementReport(report)) {
    return (
      <FinancialStatementModal
        isOpen={isOpen}
        onClose={onClose}
        report={report as FinancialStatementReportItem}
        modalTitle={modalTitle}
        submitText={submitText}
        isEditMode={isEditMode}
        onSave={(data) => {
          const updatedReport = { ...report, ...data };
          onSave(updatedReport);
        }}
        entityId={entityId}
        selectedReports={selectedReports}
      />
    );
  }

  if (isAgingSummaryReport(report)) {
    return (
      <AgingSummaryModal
        isOpen={isOpen}
        onClose={onClose}
        report={report as AgingSummaryReportItem}
        modalTitle={modalTitle}
        submitText={submitText}
        onSave={(data) => {
          const updatedReport = { ...report, ...data };
          onSave(updatedReport);
        }}
      />
    );
  }

  if (isRevenueRecognitionReport(report)) {
    return (
      <RevenueRecognitionModal
        isOpen={isOpen}
        onClose={onClose}
        report={report as RevenueRecognitionReportItem}
        modalTitle={modalTitle}
        submitText={submitText}
        onSave={(data) => {
          const updatedReport = { ...report, ...data };
          onSave(updatedReport);
        }}
        selectedReports={selectedReports}
      />
    );
  }

  if (isTrialBalanceReport(report)) {
    return (
      <TrialBalanceModal
        isOpen={isOpen}
        onClose={onClose}
        report={report as TrialBalanceReportItem}
        modalTitle={modalTitle}
        submitText={submitText}
        isEditMode={isEditMode}
        onSave={(data) => {
          const updatedReport = { ...report, ...data };
          onSave(updatedReport);
        }}
        entityId={entityId}
        selectedReports={selectedReports}
      />
    );
  }

  if (isCustomReport(report)) {
    return (
      <CustomReportModal
        isOpen={isOpen}
        onClose={onClose}
        report={report as CustomReportItem}
        modalTitle={modalTitle}
        submitText={submitText}
        isEditMode={isEditMode}
        selectedReports={selectedReports}
        onSave={(data) => {
          const updatedReport = { ...report, ...data };
          onSave(updatedReport);
        }}
      />
    );
  }

  return null;
};
